import { render } from "./ResizeBottomRight.vue?vue&type=template&id=4502e711"
import script from "./ResizeBottomRight.vue?vue&type=script&lang=js"
export * from "./ResizeBottomRight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ResizeBottomRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4502e711"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4502e711', __exports__)) {
    api.reload('4502e711', __exports__)
  }
  
  module.hot.accept("./ResizeBottomRight.vue?vue&type=template&id=4502e711", () => {
    api.rerender('4502e711', render)
  })

}


export default __exports__